import { render, staticRenderFns } from "./registration_answer_report.vue?vue&type=template&id=8cdf8c4e&"
import script from "./registration_answer_report.vue?vue&type=script&lang=js&"
export * from "./registration_answer_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports